import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class recetaService { 
    
    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/receta/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPorEstado(filter) {
        const response = await axios
            .get(`${ERP}logistica/receta/listar-por-estado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/receta/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async obtenerDetallePorId(id) {
        const response = await axios
            .get(`${ERP}logistica/receta/detalle/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async listarEstado() {
        const response = await axios
            .get(`${ERP}logistica/receta/estado`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }


    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/receta/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/receta/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfA4(id) {
        const response = await axios
            .get(`${ERP}logistica/receta/pdf-a4/${id}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/receta`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/receta`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async actualizarEstado(data) {
        const response = await axios
            .put(`${ERP}logistica/receta/actualizar-estado`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    
    /******* TRANSACCIONES ******/
}

export default new recetaService();